/*!
 *
 *	localmenu.js
 *
 */

module.exports = function(){
	var $li = $('.st-Global_List_Item:has(".st-Global_Local")');
	$li.on('mouseover', function(){
		$(this).children('.st-Global_Local').stop(true, false).slideDown(300);
	}).on('mouseleave', function(){
		$(this).children('.st-Global_Local').stop(true, false).slideUp(300);
	});

	$li.children('a').on('tap click', function(e){
		e.preventDefault();
	});
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/localmenu.js
// module id = 20
// module chunks = 0